import React from "react";
import { Grid } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DyanamicDropdown from "components/Elements/DynamicDropdown";
import { useFilters } from "../FilterContext";
import { useFilterInitialization } from "./hooks/useFilterInitialization";

const GROUPING_OPTIONS = [
	{ id: "floc", name: "FLOC" },
	{ id: "siteAsset", name: "Site Asset" },
];

export const AssetGroupingFilter = () => {
	const { filterValues, updateFilter } = useFilters();

	useFilterInitialization("assetGrouping", GROUPING_OPTIONS, {
		waitForData: false,
		getDefaultValue: () => GROUPING_OPTIONS[0],
		getParams: (item) => ({ assetGrouping: item.id || "floc" }),
	});

	if (!filterValues.assetGrouping) return null;

	const handleChange = (item) => {
		updateFilter("assetGrouping", item, { assetGrouping: item.id || "floc" });
	};

	return (
		<Grid item lg={3} md={6} xs={12}>
			<DyanamicDropdown
				dataSource={GROUPING_OPTIONS}
				columns={[{ name: "name", id: 1 }]}
				showHeader={false}
				width="100%"
				placeholder="Select Grouping"
				onChange={handleChange}
				selectdValueToshow="name"
				selectedValue={filterValues.assetGrouping?.value}
				label="Group by"
				icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
				required={false}
				showBorderColor
			/>
		</Grid>
	);
};
